import { RateCoverageComponents } from "../../../client/types.gen";

export type FactorRow = {
  comp: RateCoverageComponents;
};

/*
 * Returns the "weighted average" of each factor in the following sense: What is
 * the number c such that if you replaced all values for a factor with c, the total
 * premium remains unchanged?
 *
 * A good alternative here might be geometric mean - there are arguments for both.
 */
export const computeContributionWeightedAvg = (
  rows: FactorRow[],
  factorNames: string[]
): Record<string, number> => {
  const result: Record<string, number> = {};
  for (const j0 of factorNames) {
    let numerator = 0;
    let denominator = 0;
    for (const row of rows) {
      const xi = row.comp.base_rate * (row.comp.building_value / 100);
      let pi = xi;
      for (const [name, value] of Object.entries(row.comp.factors)) {
        if (name !== j0) {
          pi *= value;
        }
      }
      const wij0 = row.comp.factors[j0] ?? 1;
      numerator += pi * wij0;
      denominator += pi;
    }
    result[j0] = denominator !== 0 ? numerator / denominator : NaN;
  }
  return result;
};
